import React, { useContext } from 'react';
import { FiX } from 'react-icons/fi';
import { Link, useLocation } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { SidebarContext } from '../../contentApi/sideBarToggleProvider';
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelopeOpen, faClone, faFile, faCreditCard, faFileCode } from '@fortawesome/free-regular-svg-icons';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import * as FeatherIcons from "react-icons/fi"; 

const SettingSidebar = () => {
    const language = useUserLanguage();
    const { translations } = useTranslations(language);
    const getText = (key, defaultValue) => translations[key] || defaultValue;
    const { sidebarOpen, setSidebarOpen } = useContext(SidebarContext);
    const pathName = useLocation().pathname;

    const navItems = [
        { label: getText("MENU_SETTINGS_GENERAL"), path: "/settings/ganeral", icon: "settings.svg" },
        { label: getText("MENU_SETTINGS_SEO"), path: "/settings/seo", icon: "device-tablet-search.svg" },
        { label: getText("MENU_SETTINGS_EMAIL"), path: "/settings/email", icon: "mail-forward.svg" },
        { label: getText("MENU_SETTINGS_MAILJET"), path: "/settings/api", icon: "send.svg" },
        { label: getText("MENU_SETTINGS_IP_SECURITY"), path: "/settings/ip", icon: "shield-code.svg" },
        { label: getText("MENU_SETTINGS_CDN"), path: "/settings/cdn", icon: "cloud-up.svg" },
        { label: getText("MENU_SETTINGS_EXTENSIONS"), path: "/settings/support", icon: "files.svg" },
        { label: getText("MENU_SETTINGS_TRACKING"), path: "/settings/gateways", icon: "credit-card-pay.svg" },
        { label: getText("MENU_SETTINGS_SMS"), path: "/settings/miscellaneous", icon: "message-2.svg" },
        { label: getText("MENU_SETTINGS_CONTROL"), path: "/settings/control", icon: "adjustments-alt.svg" },
        { label: getText("MENU_SETTINGS_IMAGE"), path: "/settings/image", icon: "image-in-picture.svg" },
        { label: getText("MENU_SETTINGS_INVOICE"), path: "/settings/invoice", icon: "file-invoice.svg" },
        { label: getText("MENU_SETTINGS_KDV"), path: "/settings/kdv", icon: "receipt-tax.svg" },
        { label: getText("MENU_SETTINGS_GOOGLE_API"), path: "/settings/localization", icon: "presentation-analytics.svg" },
        { label: getText("MENU_SETTINGS_GOOGLE_INDEX"), path: "/settings/index", icon: "list-search.svg" },
        { label: getText("MENU_SETTINGS_ONESIGNAL"), path: "/settings/onesignal", icon: "device-mobile-message.svg" },
        { label: getText("MENU_SETTINGS_DOMAIN"), path: "/settings/domain", icon: "world-www.svg" },
        { label: getText("MENU_SETTINGS_RECAPTCHA"), path: "/settings/recaptcha", icon: "world-check.svg" },
      ];
      

    return (
        <div className={`content-sidebar content-sidebar-md ${sidebarOpen ? "app-sidebar-open" : ""} `}>
            <PerfectScrollbar>
                <div className="content-sidebar-header bg-white sticky-top hstack justify-content-between">
                    <h4 className="fw-bolder mb-0">{getText("MENU_SETTINGS")}</h4>
                    <a href="#" className="app-sidebar-close-trigger d-flex" onClick={() => setSidebarOpen(false)}>
                        <FiX size={16} />
                    </a>
                </div>
                <div className="content-sidebar-body">
                    <ul className="nav flex-column nxl-content-sidebar-item">
                    {navItems.map(({ label, path, icon }, index) => {
                            let IconComponent;

                            // If the icon is a Feather icon
                            if (typeof icon === "string" && icon.startsWith("Fi")) {
                                const FeatherIconComponent = FeatherIcons[icon];
                                IconComponent = () => <FeatherIconComponent size={16} className="icon-size me-2" />;
                            }
                            // If the icon is a FontAwesome icon
                            else if (typeof icon !== "string") {
                                IconComponent = () => (
                                    <FontAwesomeIcon icon={icon} className="icon-size me-2" style={{ fontSize: "16px" }} />
                                );
                            }
                            // If the icon is a Google Material Icon
                            else if (icon === "google-smartphone") {
                                IconComponent = () => (
                                    <span className="material-symbols-outlined icon-size me-2" style={{ fontSize: "18px" }}>
                                        smartphone
                                    </span>
                                );
                            } 
                            else if (icon === "google-recaptcha") {
                                IconComponent = () => (
                                    <span className="material-symbols-outlined icon-size me-2" style={{ fontSize: "16px" }}>
                                        code
                                    </span>
                                );
                            }
                            // If the icon is a custom SVG icon from public/icons/svg/
                            else {
                                IconComponent = () => (
                                    <img
                                        src={`${process.env.PUBLIC_URL}/icons/svg/${icon}`} // Custom icon from public/icons/svg/
                                        alt={label}
                                        style={{ width: 20, height: 20 }}
                                    />
                                );
                            }

                            return (
                                <li key={index} className="nav-item">
                                    <Link className={`nav-link ${pathName === path ? "active" : ""} `} to={path}>
                                        {IconComponent && <IconComponent />}
                                        <span>{label}</span>
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </PerfectScrollbar>
        </div>
    );
};

export default SettingSidebar;
